export const styles = () => ({
  draggableContainer: {
    pointerEvents: 'none',
    position: 'fixed',
    zIndex: 100,
  },
});
